import { render, staticRenderFns } from "./AddDashboardSectionDialog.vue?vue&type=template&id=f34ace74"
import script from "./AddDashboardSectionDialog.vue?vue&type=script&lang=js"
export * from "./AddDashboardSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports